<template>
  <div id="table-rdb">
  <div class="table-wrapper">
    <div class="md:tw-flex justify-space-between tw-pb-2">
      <div class="tw-hidden md:tw-flex">
        <div class="hover:tw-bg-super-light-green tw-px-2 tw-pt-2 tw-rounded-md tw-pl-8 tw-relative">
          <span class="tw-absolute tw--top-3 tw-left-2">
            <v-checkbox
              :value="selectAll"
              color="#6ec39b"
              class="remove-checkbox-padding"
              @change="onChangeSelectAll($event)"
            ></v-checkbox>
          </span>
          <v-icon class="tw-mt-0" v-on:click="showSelector = !showSelector">mdi-chevron-down</v-icon>

          <div class="tw-absolute tw-z-30 tw-bg-white tw-w-40 tw-shadow-md tw-py-2 tw-px-4 tw-rounded-md"
               v-if="showSelector">
            <div class="tw-text-center tw-font-bold">เลือกเฉพาะ</div>
            <div class="tw-pb-2 tw-pt-2 hover:tw-text-light-green tw-cursor-pointer" @click="clickSelectedAllByType('all')">เอกสารทั้งหมด</div>
            <div class="tw-pb-2 tw-pt-2 hover:tw-text-light-green tw-cursor-pointer" @click="clickSelectedAllByType('downloaded')">ดาวน์โหลดแล้ว</div>
            <div class="tw-pb-2 tw-pt-2 hover:tw-text-light-green tw-cursor-pointer" @click="clickSelectedAllByType('notDownload')">ยังไม่ได้ดาวน์โหลด</div>
            <div class="tw-pb-2 tw-pt-2 hover:tw-text-light-green tw-cursor-pointer" @click="clickSelectedAllByType('notSendEmail')">ยังไม่ได้ส่งอีเมล</div>
<!--            <div class="tw-pb-2 tw-pt-2 hover:tw-text-light-green tw-cursor-pointer" @click="clickSelectedAllByType('suspenseAccount')">บัญชีพัก</div>-->
          </div>
        </div>

        <div class="tw-flex">
          <div class="tw-pt-2 tw-mx-1">เลือก <span class="tw-text-light-green">{{this.selectedList.length}}</span> ฉบับ</div>
          <button @mouseover="downloadXMLHover = true" @mouseleave="downloadXMLHover = false"
                  @click.prevent="downloadZip('xml')"
                  class="group hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green"
                  v-if="!holdDownloadAndSendEmail(this.companyStatus)">
            <img src="/images/icons/icon_download_xml.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="!downloadXMLHover">
            <img src="/images/icons/icon_download_xml_white.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="downloadXMLHover">
            ดาวน์โหลด XML ( {{ this.docXmlUrlList.length }} )
          </button>
          <button @mouseover="downloadPDFHover = true" @mouseleave="downloadPDFHover = false"
                  @click.prevent="downloadZip('pdf')"
                  class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green"
                  v-if="!holdDownloadAndSendEmail(this.companyStatus)">
            <img src="/images/icons/icon_download_pdf.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="!downloadPDFHover">
            <img src="/images/icons/icon_download_pdf_white.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="downloadPDFHover">
            ดาวน์โหลด PDF ( {{ this.docPdfUrlList.length }} )
          </button>
          <v-dialog v-model="emailDialog" persistent max-width="600px" v-if="!holdDownloadAndSendEmail(this.companyStatus)">
            <template v-slot:activator="{ on, attrs }">
              <button @mouseover="sentEmailHover = true" @mouseleave="sentEmailHover = false" v-bind="attrs" v-on="on"
                      class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green">
                <img src="/images/icons/icon _send_email.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="!sentEmailHover">
                <img src="/images/icons/icon _send_email_white.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="sentEmailHover">
                ส่งอีเมล
              </button>
            </template>
            <template>
              <v-form ref="form" v-model="emailValid">
                <v-card>
                  <v-card-title>
                    <b>ส่งอีเมล</b>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-autocomplete
                            v-model="emailValues"
                            :items="emailList"
                            :rules="emailRules"
                            outlined
                            dense
                            chips
                            deletable-chips
                            small-chips
                            label="กรุณากรอกอีเมล"
                            multiple
                            hide-selected
                            append-icon=""
                            hide-no-data
                            @keydown.tab.prevent="autocompleteAddEmail($event.target.value)"
                            @keydown.enter.prevent="autocompleteAddEmail($event.target.value)"
                            :search-input.sync="emailInput"
                            @change="removeEmail"
                            @blur="autocompleteAddEmail($event.target.value)"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="emailDialog = false" :disabled="sendEmailLoading">
                      <v-icon large>mdi-close-circle-outline</v-icon>
                      <b>ยกเลิก</b>
                    </v-btn>
                    <v-btn text color="#6ec39b" type="submit" class="submit-email" :disabled="sendEmailLoading" @click="validateEmail">
                      <img
                        src="/images/icons/icon_send_email.svg"
                        style="max-height: 26px; max-width: 26px;"
                        class="mr-2" />
                      <b>ส่งอีเมล</b>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </template>
          </v-dialog>
<!--          <button @mouseover="suspendedHover = true" @mouseleave="suspendedHover = false"-->
<!--                  class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green">-->
<!--            <img src="/images/icons/icon_suspended.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="!suspendedHover">-->
<!--            <img src="/images/icons/icon_suspended_white.svg" class="tw-float-left tw-w-5 tw-mr-2" v-if="suspendedHover">-->
<!--            บัญชีพัก-->
<!--          </button>-->
        </div>

      </div>

      <div class="tw-flex">
        <div class="tw-relative">
          <button class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-relative" v-on:click="showFilter = !showFilter">
            <img src="/images/icons/icon_filter_gray.svg" class="tw-float-left tw-mt-0.5 tw-mr-2"/>กรอง
          </button>
          <filter-table :is-visible="showFilter" :set-filter-table="setFilter"></filter-table>
        </div>
        <div class="tw-relative">
          <button class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md" v-on:click="showHideColumn = !showHideColumn">
            <img src="/images/icons/icon_hidden_gray.svg" class="tw-float-left tw-mt-1.5 tw-mr-2"/>ซ่อน
          </button>
          <div class="tw-absolute tw-top-2 tw-right-0 tw-bg-white tw-w-auto tw-top-12 tw-shadow-lg tw-rounded-md tw-z-10 tw-p-2" v-if="showHideColumn">
           <div class="tw-m-1 tw-text-center tw-font-semibold">เลือกคอลัมน์ที่ต้องการซ่อน</div>
            <v-list>
              <v-list-item v-for="(option, index) in optionHideList" :key="index">
                <v-list-item-title>{{ option.label }}</v-list-item-title>
                <v-list-item-action>
                  <v-checkbox :input-value="valueHideList" :value="option.key"
                              @change="onSelectOptionHide(option.key)"></v-checkbox>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <div class="tw-relative">
          <button class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md" v-on:click="showSearch = !showSearch">
            <img src="/images/icons/icon_search_gray.svg" class="tw-float-left tw-mt-0.5 tw-mr-2"/>ค้นหา
          </button>
          <div class="tw-absolute tw-top-2 tw-right-0 tw-bg-white tw-w-auto tw-top-12 tw-shadow-lg tw-rounded-md tw-z-10 tw-p-2" v-if="showSearch">
            <div class="tw-flex">
              <v-text-field label="ค้นหา" outlined class="tw-w-60 tw-p-0 tw-m-1 search-input" v-model="search"></v-text-field>
            </div>
          </div>
        </div>
        <div>
          <button class="hover:tw-bg-light-green hover:tw-text-white tw-px-4 tw-py-2 tw-rounded-md">
            <img src="/images/icons/icon_menu_setting_gray.svg" class="tw-float-left tw-mt-0.5 tw-mr-2"/>ตั้งค่า
          </button>
        </div>
      </div>
    </div>
    <div v-if="alert.show">
      <v-alert v-model="alert.show" :type="alert.type" transition="scale-transition" dismissible>
        {{ alert.text }}
      </v-alert>
    </div>
    <v-dialog v-model="pdfDialog">
     <iframe class="iframe" :src="pdfSrc"></iframe>
    </v-dialog>

    <div class="tw-overflow-x-scroll tw-relative">
      <table class="table-fixed tw-w-full tw-min-w-max tw-text-sm">
        <tr class="tw-bg-light-red">
          <th class="tw-sticky tw-left-0 tw-bg-light-red tw-py-3 tw-px-1 tw-w-14 tw-z-5"></th>
          <th class="tw-sticky tw-left-10 tw-bg-light-red tw-py-3 tw-px-1 tw-w-28 tw-z-5">วันที่เอกสาร
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-ed_issue_date_time')" v-if="defaultOrder( 'ed_issue_date_time')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder( 'ed_issue_date_time')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('ed_issue_date_time')" v-if="isCheckOrder('-ed_issue_date_time')"/>
          </th>
          <th class="tw-sticky tw-left-36 tw-bg-light-red tw-py-3 tw-px-1 tw-w-20 tw-text-center tw-z-5">ประเภท</th>
          <th class="tw-sticky tw-left-56 tw-bg-light-red tw-py-3 tw-px-1 tw-w-32 tw-z-5">เลขที่
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-object_id')" v-if="defaultOrder( 'object_id')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('object_id')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('object_id')" v-if="isCheckOrder('-object_id')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-28 tw-text-left" v-if="showColumn('scttAhtaBtpId')">รหัสลูกค้า
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahta_btp_id')" v-if="defaultOrder( 'sctt_ahta_btp_id')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahta_btp_id')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahta_btp_id')" v-if="isCheckOrder('-sctt_ahta_btp_id')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-64 tw-text-left" v-if="showColumn('scttAhtaBtpName')">ชื่อลูกค้า / ชื่อบริษัท
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahta_btp_name')" v-if="defaultOrder( 'sctt_ahta_btp_name')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahta_btp_name')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahta_btp_name')" v-if="isCheckOrder('-sctt_ahta_btp_name')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-36 tw-text-center" v-if="showColumn('scttAhtaBtpStrId')">เลขที่ผู้เสียภาษี
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahta_btp_str_id')" v-if="defaultOrder( 'sctt_ahta_btp_str_id')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahta_btp_str_id')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahta_btp_str_id')" v-if="isCheckOrder('-sctt_ahta_btp_str_id')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-44 tw-text-right" v-if="showColumn('scttAhtsStshmsTaxBasisTotalAmount')">มูลค่าที่นำมาคิดภาษี
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahts_stshms_line_total_amount')" v-if="defaultOrder( 'sctt_ahts_stshms_line_total_amount')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahts_stshms_line_total_amount')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahts_stshms_line_total_amount')" v-if="isCheckOrder('-sctt_ahts_stshms_line_total_amount')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-32 tw-text-right" v-if="showColumn('scttAhtsStshmsTaxTotalAmount')">ภาษีมูลค่าเพิ่ม
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahts_stshms_tax_total_amount')" v-if="defaultOrder( 'sctt_ahts_stshms_tax_total_amount')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahts_stshms_tax_total_amount')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahts_stshms_tax_total_amount')" v-if="isCheckOrder('-sctt_ahts_stshms_tax_total_amount')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-28 tw-text-right" v-if="showColumn('scttAhtsStshmsGrandTotalAmount')">ยอดรวม
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-sctt_ahts_stshms_grand_total_amount')" v-if="defaultOrder( 'sctt_ahts_stshms_grand_total_amount')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('sctt_ahts_stshms_grand_total_amount')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('sctt_ahts_stshms_grand_total_amount')" v-if="isCheckOrder('-sctt_ahts_stshms_grand_total_amount')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-32 tw-text-center" v-if="showColumn('timeSignedXml')">ซิงค์ข้อมูล
            <img
              src="/images/icons/menu-swap.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('-time_signed_xml')" v-if="defaultOrder( 'time_signed_xml')"/>
            <img
              src="/images/icons/menu-up.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('')" v-if="isCheckOrder('time_signed_xml')"/>
            <img
              src="/images/icons/menu-down.svg"
              style="max-height: 26px; max-width: 26px;"
              class="mr-2 tw-cursor-pointer icon-order-opcity"
              @click="changeOrder('time_signed_xml')" v-if="isCheckOrder('-time_signed_xml')"/>
          </th>
          <th class="tw-py-3 tw-px-1 tw-w-36" v-if="showColumn('xmlAndEmail')">สถานะเอกสาร / อีเมล</th>
        </tr>
        <tr  v-for="edges in documentList" :key="edges.node.id" class="tw-group">
          <td class="tw-sticky tw-left-0 tw-z-5 tw-py-0 tw-px-1 tw-text-left tw-bg-white group-hover:tw-bg-light-gray">
            <v-checkbox
              color="#6ec39b"
              :input-value="getCheckedSelect(edges.node['objectId'])"
              class="remove-checkbox-padding"
              @change="clickSelected(edges.node)"
            ></v-checkbox>
          </td>
          <td class="tw-sticky tw-left-10 tw-z-5 tw-py-0 tw-px-1 tw-text-left tw-cursor-pointer tw-bg-white group-hover:tw-bg-light-gray"
              @mousedown="startDrag"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            <img src="/images/icons/icon_download.svg" class="tw-float-left tw--mt-1 tw-mr-1"
                 v-if="edges.node['downloadedXml']"> {{ getDateWithFormat(edges.node['edIssueDateTime']) }}
          </td>
          <td class="tw-sticky tw-left-36 tw-z-5 tw-py-0 tw-px-1 tw-text-center tw-cursor-pointer tw-bg-white group-hover:tw-bg-light-gray"
              @mousedown="startDrag"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            {{ getDocumentType(edges.node['docType']) }}
          </td>
          <td class="tw-sticky tw-left-56 tw-z-5 tw-py-0 tw-px-1 tw-text-center tw-cursor-pointer tw-bg-white group-hover:tw-bg-light-gray"
              @mousedown="startDrag"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            {{ edges.node['objectId'] }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-left tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
               v-if="showColumn('scttAhtaBtpId')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">{{ edges.node['scttAhtaBtpId'] }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-left tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
              v-if="showColumn('scttAhtaBtpName')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">{{ edges.node['scttAhtaBtpName'] }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-center tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
              v-if="showColumn('scttAhtaBtpStrId')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">{{ edges.node['scttAhtaBtpStrId'] }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-right tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
              v-if="showColumn('scttAhtsStshmsTaxBasisTotalAmount')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            {{ calAmount(edges.node['scttAhtsStshmsTaxBasisTotalAmount']) }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-right tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
               v-if="showColumn('scttAhtsStshmsTaxTotalAmount')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            {{ calAmount(edges.node['scttAhtsStshmsTaxTotalAmount']) }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-right tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
                v-if="showColumn('scttAhtsStshmsGrandTotalAmount')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">
            {{ calAmount(edges.node['scttAhtsStshmsGrandTotalAmount']) }}
          </td>
          <td class="tw-py-0 tw-px-1 tw-text-center tw-cursor-pointer group-hover:tw-bg-light-gray" @mousedown="startDrag"
               v-if="showColumn('timeSignedXml')"
              @mouseup="stopDrag(edges.node)" @mousemove="doDrag">{{ timeFormat(edges.node['timeSignedXml']) }}
          </td>
          <td class="tw-text-center group-hover:tw-bg-light-gray" v-if="showColumn('xmlAndEmail')">
            <div class="tw-flex tw-justify-center">
              <img src="/images/icons/icon_doc_ready.svg" class="tw-mx-1 tw-cursor-pointer"
                   v-if="edges.node['signedXmlUrl']">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <img width="22px" height="24px"
                         class="tw-mx-1 tw-cursor-pointer"
                         src="/images/icons/icon_status_doc_error.svg"
                         alt="error-status"
                         v-bind="attrs"
                         v-on="on"
                         v-if="JSON.parse(JSON.parse(edges.node['errors'])).length > 0"/>
                  </template>
                  <span>{{ errorsMessage(JSON.parse(JSON.parse(edges.node['errors']))) }}</span>
                </v-tooltip>
              <img src="/images/icons/icon_sent_email.svg" class="tw-mx-1 tw-cursor-pointer"
                   v-if="edges.node['mailSent']">
            </div>
          </td>
        </tr>
      </table>
      <v-progress-linear indeterminate color="green" :active="loading || downloadPdfLoading"></v-progress-linear>
    </div>
    <div class="float-left mt-2">
      <div class="tw-relative">
        <v-btn class="ma-2 page-arrow-size" outlined color="#707070" @click="onClickPreviousPagination"
               :disabled="!canPrevPage() || $apollo.loading">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn class="page-count-size" outlined color="#c9242b">
          {{ page }}
        </v-btn>
        <v-btn class="ma-2 page-arrow-size" outlined color="#707070" @click="onClickNextPagination"
               :disabled="!canNextPage() || $apollo.loading">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <button class="hover:tw-bg-light-gray tw-px-4 tw-py-2 tw-rounded-md"
                v-on:click="showPagination = !showPagination">
          <span>{{ getPageDesc() }}</span>
        </button>
        <div class="tw-absolute tw-right-0 tw-bg-white tw-w-52 tw-shadow-lg tw-rounded-md tw-p-2"
             v-if="showPagination">
          <v-radio-group :value="itemsPerPage" column @change="onChangePagination">
            <v-radio
              label="แสดงหน้าละ 10 รายการ"
              color="#6ec39b"
              value="10"
            ></v-radio>
            <v-radio
              label="แสดงหน้าละ 30 รายการ"
              color="#6ec39b"
              value="30"
            ></v-radio>
            <v-radio
              label="แสดงหน้าละ 50 รายการ"
              color="#6ec39b"
              value="50"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import "firebase/auth"
import getDocumentTypeValue from "@/libs/getDocumentTypeValue";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import companyStatus from "@/libs/companyStatus";
import moment from "moment";
import 'moment/locale/th'
import gql from "graphql-tag";
import fc from "@/firebaseConfig";
import isMobile from "@/libs/detectMobile";
import firebase from "firebase";
import filterTable from "./filter.table";
import getErrorMessage from "@/libs/getErrorMessage";
import {mapState} from "vuex";

moment.locale('th')

const _ = require('lodash');
const axios = require("axios");

const defaultValueHideList = [
  "all",
  "scttAhtaBtpId",
  "scttAhtaBtpName",
  "scttAhtaBtpStrId",
  "scttAhtsStshmsTaxBasisTotalAmount",
  "scttAhtsStshmsTaxTotalAmount",
  "scttAhtsStshmsGrandTotalAmount",
  "timeSignedXml",
  "xmlAndEmail",
]

export default {
  name: 'Document',
  components: {filterTable},
  computed: mapState({
    companyStatus: state => state.statusesByCompany.companyStatus,
  }),
  data: function () {
    return {
      downloadXMLHover: false,
      downloadPDFHover: false,
      sentEmailHover: false,
      suspendedHover: false,
      showSelector: false,
      showFilter: false,
      showPagination: false,
      showHideColumn: false,
      showSearch: false,
      documentList:[],
      order:"-ed_issue_date_time",
      selectedList:[],
      selectAll: false,
      mouse: false,
      dragging: false,
      alert: {
        text: "",
        type: "success",
        show: false,
      },
      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      loading: false,
      optionHideList: [
        {label: 'แสดงทั้งหมด', key: 'all'},
        {label: 'รหัสลูกค้า', key: 'scttAhtaBtpId'},
        {label: 'ชื่อลูกค้า / ชื่อบริษัท', key: 'scttAhtaBtpName'},
        {label: 'เลขที่ผู้เสียภาษี', key: 'scttAhtaBtpStrId'},
        {label: 'มูลค่าที่นำมาคิดภาษี', key: 'scttAhtsStshmsTaxBasisTotalAmount'},
        {label: 'ภาษีมูลค่าเพิ่ม', key: 'scttAhtsStshmsTaxTotalAmount'},
        {label: 'ยอดรวม', key: 'scttAhtsStshmsGrandTotalAmount'},
        {label: 'ซิงค์ข้อมูล', key: 'timeSignedXml'},
        {label: 'สถานะเอกสาร / อีเมล', key: 'xmlAndEmail'},
      ],
      valueHideList: _.cloneDeep(defaultValueHideList),

      // pagination
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage: localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit"), // hardcode for auto case
      first: localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,

      sendEmailLoading: false,
      emailRules: [
        v => (!!v && this.emailValues.length > 0) || 'E-mail is required',
      ],
      emailValid: false,
      emailDialog: false,
      sendEmailSuccessCount: 0,
      docXmlUrlList: [],
      docPdfUrlList: [],
      search:"",

      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null
        }
      },

      emailList: [],
      emailValues: [],
      emailInput: "",
      awaitingDrag: false,
      timer: false
    }
  },
  created() {
    this.loading = true
    this.$apollo.queries.docs.start()
  },
  methods:{
     startDrag() {
       this.timer = false
       this.dragging = false
       this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse && !this.downloadPdfLoading) {
        this.onClickDocId(doc)
      }
      this.dragging = false
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    getDateWithFormat: function (date) {
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2,4);

      return formattedDate;
    },
    changeOrder: function (order){
      this.order = order
    },
    getDocumentType: function (docType){
      return getDocumentTypeValue(docType)
    },
    timeFormat: function (date) {
      if (date) {
        return moment(new Date(date)).add(543, 'year').format('Do MMM YY, LTS')
      }
      return "-"
    },
    calAmount: function (amount){
      return formatTwoDecimal(amount)
    },
    defaultOrder: function (name) {
      let nameOpposite = "-" + name
      return !this.isCheckOrder(name) && !this.isCheckOrder(nameOpposite);

    },
    isCheckOrder: function (name) {
      return this.order === name
    },
    getCheckedSelect: function (docID){
      return this.selectedList.some(x => x['docID'] === docID);
    },
    showColumn(field) {
      return this.valueHideList.includes(field)
    },
    checkSelectType: function(selectType, docNode){
      switch (selectType) {
        case "all":
          return true
        case "downloaded":
          return docNode['downloadedXml']
        case "notDownload":
          return !docNode['downloadedXml']
        case "notSendEmail":
          return !docNode['mailSent']
        default:
          return false
      }
    },
    clickSelectedAllByType: function (selectType) {
      this.showSelector = false
      let selectedList = []
      this.documentList.forEach((doc) => {
        let docNode = doc.node
        if (this.checkSelectType(selectType, docNode)) {
          selectedList.push({
            docID: docNode['objectId'],
            pdfUrl: docNode['signedPdfUrl'],
            xmlUrl: docNode['signedXmlUrl']
          })
        }
      })
      this.selectAll = selectType === "all";
      this.selectedList = selectedList
      this.$store.dispatch('docs/setSelectedList', {selectedList: selectedList})
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList)
      let objectId = doc['objectId']

      if(this.getCheckedSelect(objectId)){
        let index = valueList.findIndex(x => x['docID'] === objectId)
        valueList.splice(index, 1);
      }else{
        valueList.push({docID : objectId, pdfUrl: doc['signedPdfUrl'], xmlUrl: doc['signedXmlUrl']})
      }
      this.selectedList = valueList
      this.$store.dispatch('docs/setSelectedList', {selectedList: valueList})
    },
    onChangeSelectAll: function (check){
      this.clickSelectedAllByType(check ? 'all': 'unCheckAll')
    },
    loadingDownloadZip: function(type, onOff) {
      let boolean = onOff === 'on'
      if (type === 'xml') this.$store.dispatch('docsDownloaded/updateDownloadingXml', {downloadingXml: boolean})
      else this.$store.dispatch('docsDownloaded/updateDownloadingPdf', {downloadingPdf: boolean})
    },
    downloadZip: async function (type) {
      this.loadingDownloadZip(type, 'on')
      let urlField = 'pdfUrl'
      if (type === 'xml') {
        urlField = 'xmlUrl'
      }
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token,
      }
      let docList = []
      let timeStamp = new Date().getTime()
      // เอาเฉพาะแถวที่มี url
      await this.selectedList.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({id: docSelect['docID'], url: docSelect[urlField]})
        }
      })
      await axios.post(
        fc.cloudFunctionUrl + "zipFiles",
        {data: docList, type: type, companyID: this.$route.params.companyId},
        {headers, responseType: 'arraybuffer'}
      )
        .then((result) => {
          if (result.data.byteLength !== 0) {
            let url = URL.createObjectURL(new Blob([result.data], {type: 'application/zip'}));
            const link = document.createElement('a');
            link.href = url
            link.setAttribute('download', timeStamp + '.zip');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          }
          this.loadingDownloadZip(type, 'off')
          this.clearSelectList();
        }, (error) => {
          console.log("front end error: ", error);
          this.loadingDownloadZip(type, 'off')
        });
    },
    clearSelectList: function (){
      this.$store.dispatch('docs/setSelectedList', {selectedList: []})
    },
    clearAllSelectList: function () {
      this.selectAll = false
      this.selectedList = []
      this.clearSelectList();
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.sendEmail()
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true

      // get user token
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token
      }

      const promises = this.selectedList.map(async (select) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: select['docID'],
          email: this.emailValues,
        }

        await axios.post(fc.cloudFunctionUrl + "sendemail", data, {headers})
          .then((response) => {
            if (response.status === 200) {
              this.sendEmailSuccessCount++
            }

          }, (error) => {
            console.log(error)
          });
      })

      await Promise.all(promises)
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = {text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ", type: "success", show: true}

        this.sendEmailSuccessCount = 0
        this.sendEmailLoading = false
        this.emailDialog = false
        this.emailValues = []
        this.emailList = []
        this.$refs.form.resetValidation()
        this.$apollo.queries.docs.start()
      }
    },
    updateUnsignedPdf: async function (docID) {
      // get user token
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token
      }
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      }

      const promise = new Promise((resolve, reject) => {
        axios.post(fc.cloudFunctionUrl + "updateUnsignedPdf", data, {headers})
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data)
            }
          }, (error) => {
            reject(error)
            console.log(error)
          })
      })
      return Promise.all([promise])
    },
    onClickDocId: async function (doc) {
      this.downloadPdfLoading = true

      let pdfLink = doc['signedPdfUrl']
      let unsigedPdfLink = doc['unsignedPdfUrl']

      let link = ""
      if (!pdfLink && !unsigedPdfLink) {
        link = await this.updateUnsignedPdf(doc['objectId'])
      } else if (pdfLink) {
        link = pdfLink
      } else if (unsigedPdfLink) {
        link = unsigedPdfLink
      }

      if (!this.pdfDialog && link) {
        await axios.get(link, {
          responseType: 'arraybuffer',
        })
          .then((response) => {
            this.downloadPdfLoading = false

            let url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));

            if (isMobile()) {
              let a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = url;
              a.download = "invoice_" + new Date().getTime() + ".pdf";
              a.click();
              window.URL.revokeObjectURL(url);

            } else {
              this.pdfSrc = url
              this.pdfDialog = true
            }

          }, (error) => {
            console.log(error)
          });
      }
    },
    onSelectOptionHide: function (key) {
      let valueList = _.cloneDeep(this.valueHideList)
      if (key === 'all') {
        if (!valueList.includes(key)) {
          valueList = defaultValueHideList
        } else {
          valueList = []
        }
      } else {
        if (valueList.includes(key)) {
          valueList = _.without(valueList, key)
        } else {
          valueList.push(key)
        }

        if (valueList.length === (defaultValueHideList.length - 1)) {
          if (valueList.includes("all")) {
            valueList = _.without(valueList, "all")
          } else {
            valueList.push("all")
          }
        }
      }

      this.valueHideList = valueList
    },
    onResetPage: function () {
      this.totalCount = 0
      this.edgeCount = 0
      this.page = 1
      this.itemsPerPage = localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit") // hardcode for auto case
      this.first = localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit")
      this.after = null
      this.last = null
      this.before = null
      this.hasNextPage = null
      this.hasPreviousPage = null
      this.startCursor = null
      this.endCursor = null

    },
    onClickNextPagination: function () {
      this.page += 1
      this.first = this.itemsPerPage
      this.after = this.endCursor

      this.last = null
      this.before = null

      this.hasPreviousPage = true
      this.hasNextPage = null

      this.clearAllSelectList()
    },
    onClickPreviousPagination: function () {
      this.page -= 1
      this.last = this.itemsPerPage
      this.before = this.startCursor

      this.first = null
      this.after = null

      this.hasPreviousPage = null
      this.hasNextPage = true

      this.clearAllSelectList()
    },
    canNextPage() {
      console.log("can next page", this.loading)
      if (this.hasNextPage !== null) {
        return this.hasNextPage
      } else if (this.docs) {
        return this.docs.pageInfo.hasNextPage
      } else {
        return false
      }
    },
    canPrevPage() {
      if (this.hasPreviousPage !== null) {
        return this.hasPreviousPage
      } else if (this.docs) {
        return this.docs.pageInfo.hasPreviousPage
      } else {
        return false
      }
    },
    getPageDesc() {
      let lastRow = this.page * this.itemsPerPage
      if (lastRow > this.totalCount) {
        lastRow = this.totalCount
      }
      let startRow = (this.page * this.itemsPerPage) - (this.itemsPerPage - 1)
      return `${startRow} - ${lastRow} จาก ${this.totalCount}`
    },
    onChangePagination(pageLimit) {
      this.loading = true
      let user = firebase.auth().currentUser
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('user/updatePageLimitSetting', {
          companyId: companyId,
          userId: user.uid,
          pageLimit: pageLimit
        }).then(()=> {
          this.page = 1
          this.itemsPerPage = pageLimit
          this.first = pageLimit
          this.after = null
          this.last = null
          this.before = null
          this.hasNextPage = null
          this.hasPreviousPage = null
          this.startCursor = null
          this.endCursor = null

          this.showPagination = false
          this.loading = false
        })
      }
    },
    setFilter(payload) {
      this.onResetPage();
      if (payload.docsDateRange.length === 2) {
        let issueDateTimeRange = []
        issueDateTimeRange.push(moment(payload.docsDateRange[0]).startOf('day'))
        issueDateTimeRange.push(moment(payload.docsDateRange[1]).endOf('day'))
        this.filter.issueDateTimeRange = issueDateTimeRange
      } else {
        this.filter.issueDateTimeRange = []
      }
      this.filter.objectId = payload.docsNumber
      this.filter.cttAhtaBtpId = payload.buyerCode
      this.filter.buyerBranchId = payload.buyerBranch
      this.filter.typeLineTotal = payload.productValueOperator
      this.filter.lineTotal = [...payload.productValue0, ...payload.productValue1]
      this.filter.typeTaxTotal = payload.vatOperator
      this.filter.taxTotal = [...payload.vat0, ...payload.vat0]
      this.filter.typeGrandTotal = payload.totalOperator
      this.filter.grandTotal = [...payload.total0, ...payload.total1]

      if (payload.signDateRage.length === 2) {
        let timeSignedXmlRange = []
        timeSignedXmlRange.push(moment(payload.signDateRage[0]).startOf('day'))
        timeSignedXmlRange.push(moment(payload.signDateRage[1]).endOf('day'))
        this.filter.timeSignedXmlRange = timeSignedXmlRange
      } else {
        this.filter.timeSignedXmlRange = []
      }
      this.filter.docType = payload.docsType

      //status
      if (payload.status.xmlNotDownload !== payload.status.xmlDownloadSuccess) {
        if (payload.status.xmlDownloadSuccess) {
          this.filter.status.downloadedXml = true
        } else {
          this.filter.status.downloadedXml = false
        }
      } else {
        this.filter.status.downloadedXml = null
      }
      this.filter.status.signSuccess = payload.status.signSuccess
      this.filter.status.missingInfo = payload.status.missingInfo

      if (payload.status.emailSentSuccess !== payload.status.emailSentFail) {
        if (payload.status.emailSentSuccess) {
          this.filter.status.mailSent = true
        } else {
          this.filter.status.mailSent = false
        }
      } else {
        this.filter.status.mailSent = null
      }

      this.filter.status.suspendedAccount = payload.status.suspendedAccount

      if (payload.status.emailNotFound) {
        this.filter.status.buyerEmail_Isnull = payload.status.emailNotFound
      } else {
        this.filter.status.buyerEmail_Isnull = null
      }

      this.showFilter = false
    },
    autocompleteAddEmail: function(value) {
      this.emailInput = ""
      if (value) {
        this.emailList.push(value)
         this.emailValues.push(value)
       }
    },
    removeEmail: function () {
      this.emailList = [...this.emailValues]
    },
    errorsMessage: function (errors) {
       return getErrorMessage(errors)
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status)
    }
  },
  watch: {
    selectedList: {
      handler: function (selectedList) {
        this.docXmlUrlList = []
        this.docPdfUrlList = []
        selectedList.forEach((select) => {
          if (select['xmlUrl']) {
            this.docXmlUrlList.push(select.docID)
          }
          if (select['pdfUrl']) {
            this.docPdfUrlList.push(select.docID)
          }
        })
      }
    },
    search: {
      handler: function () {
        this.onResetPage();
      }
    },
  },
  apollo: {
    docs: {
      query() {
        return gql`
          query docs ($first: Int, $last: Int, $after: String, $before: String, $companyId: String!, $order:String, $search: String, $issueDateTimeRange: [DateTime], $objectId: String, $scttAhtaBtpId: String, $buyerBranchId: String, $typeLineTotal: String, $lineTotal: [Float], $typeTaxTotal: String, $taxTotal: [Float], $typeGrandTotal: String, $grandTotal: [Float], $timeSignedXmlRange: [DateTime], $docType: String, $downloadedXml: Boolean, $signSuccess: Boolean, $hasError: Boolean, $mailSent: Boolean, $suspendedAccount: Boolean, $buyerEmail_Isnull: Boolean){
            docs: allDocument(first: $first, after: $after, last: $last, before: $before, companyId: $companyId, order:$order, search:$search, issueDateTimeRange: $issueDateTimeRange, objectId: $objectId, scttAhtaBtpId: $scttAhtaBtpId, buyerBranchId: $buyerBranchId, typeLineTotal: $typeLineTotal, lineTotal: $lineTotal, typeTaxTotal: $typeTaxTotal, taxTotal: $taxTotal, typeGrandTotal: $typeGrandTotal, grandTotal: $grandTotal, timeSignedXmlRange: $timeSignedXmlRange, docType: $docType, downloadedXml: $downloadedXml, signSuccess: $signSuccess, hasError: $hasError, mailSent: $mailSent, suspendedAccount: $suspendedAccount, buyerEmail_Isnull: $buyerEmail_Isnull){
            totalCount
            edgeCount
             edges {
                node {
                  id
                  docType
                  objectId
                  edIssueDateTime
                  scttAhtaBtpId
                  scttAhtaBtpName
                  scttAhtaBtpStrId
                  buyerBranchId
                  scttAhtsStshmsTaxBasisTotalAmount
                  scttAhtsStshmsTaxTotalAmount
                  scttAhtsStshmsGrandTotalAmount
                  timeSignedXml
                  mailSent
                  downloadedXml
                  signedXmlUrl
                  signedPdfUrl
                  unsignedPdfUrl
                  errors
                }
              }
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
              }
            }
          }
        `
      },
      variables() {
        return {
          companyId: this.$route.params.companyId,
          // companyId: 1, // test
          order: this.order,
          search: this.search,

          // pagination
          first: this.first,
          after: this.after,

          last: this.last,
          before: this.before,

          //filter
          issueDateTimeRange: this.filter.issueDateTimeRange,
          objectId: this.filter.objectId,
          scttAhtaBtpId: this.filter.scttAhtaBtpId,
          buyerBranchId: this.filter.buyerBranchId,

          typeLineTotal: this.filter.typeLineTotal,
          lineTotal: this.filter.lineTotal,

          typeTaxTotal: this.filter.typeTaxTotal,
          taxTotal: this.filter.taxTotal,

          typeGrandTotal: this.filter.typeGrandTotal,
          grandTotal: this.filter.grandTotal,

          timeSignedXmlRange: this.filter.timeSignedXmlRange,
          docType: this.filter.docType,

          //status
          downloadedXml: this.filter.status.downloadedXml,
          signSuccess: this.filter.status.signSuccess,
          hasError: this.filter.status.missingInfo,
          mailSent: this.filter.status.mailSent,
          suspendedAccount: this.filter.status.suspendedAccount,
          buyerEmail_Isnull: this.filter.status.buyerEmail_Isnull,
        }
      },
      result({ data, loading }) {
        let pageInfo = data.docs['pageInfo']
        this.startCursor = pageInfo.startCursor
        this.endCursor = pageInfo.endCursor
        this.totalCount = data.docs['totalCount']
        this.edgeCount = data.docs['edgeCount']
        if (data.docs['edges']) {
          this.documentList = data.docs['edges']
        }
        this.loading = loading
      },
      error(error) {
        console.error('We\'ve got an error!', error)
      },
    },
  },
}
</script>

<style lang="scss">
#table-rdb {
  .table-wrapper {
    /* width */
    ::-webkit-scrollbar {
      width: 10px;
      height: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .page-count-size {
    min-width: 50px !important;
  }

  .page-arrow-size {
    min-width: 60px !important;
  }

  .checkbox-box .v-input__slot {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  img {
    &.icon-order-opcity {
      display: unset;
    }
  }

  .search-input .v-text-field__details {
    display: none;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    &.submit-email {
      padding: 0 16px !important;
    }
  }

  //.tr-data:hover {
  //  background-color: #F5F5F5;
  //}
}
.iframe {
    overflow: hidden !important;
    height: 100% !important;
    width: 60% !important;
    position: absolute !important;
    left: 20% !important;
    right: 10% !important;
    top: 0 !important;
  }
</style>
